module.exports = __webpack_public_path__ + "static/media/FooterImage.46c6857b.png";